export const TrustBar = () => {
  // Placeholder company names for trust badges
  const partners = [
    'Estrella Blanca',
    'Primera Plus',
    'ETN',
    'ADO',
    'Omnibus',
    'Futura'
  ];

  return (
    <section className="bg-white py-16 border-y border-[#E5E7EB]">
      <div className="max-w-[1440px] mx-auto px-8">
        <p className="text-center text-xs text-[#6B7280] mb-12 uppercase tracking-wider font-medium">
          Líneas de autobús asociadas
        </p>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-12 items-center">
          {partners.map((partner, index) => (
            <div 
              key={index}
              className="flex items-center justify-center h-12 grayscale opacity-40 hover:opacity-60 transition-opacity"
            >
              <div className="text-center">
                <div className="text-lg font-semibold text-[#111827]">
                  {partner}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};